import { type Locale, format, parseISO } from 'date-fns';
import { convertedTime } from '../services/appointment/convertedTime';
import {
  type ServiceLocation,
  isTimeInBrowserSettings,
  removeTimePartFromDate,
} from '../helpers/appHelper';
import { timeZoneHelper } from './timeZoneHelper';
import { isSameDay } from 'date-fns';

const DAILY_REFRESH_HOUR = 3;

export const getMillisecondsUntilDailyRefresh = (now: Date): number => {
  const nextRefresh = new Date(now);
  nextRefresh.setHours(DAILY_REFRESH_HOUR, 0, 0, 0);

  if (nextRefresh <= now) {
    nextRefresh.setDate(nextRefresh.getDate() + 1);
  }

  return nextRefresh.getTime() - now.getTime();
};

// Pass in a date and get a UTC Timestamp in ISOString
const convertDateToZulu = (stringDate: string) => {
  if (!stringDate || stringDate.length === 0) {
    return stringDate;
  }

  const date = new Date(stringDate);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth(); // Month is 0-indexed! 0 = january
  const day = date.getUTCDate();

  return new Date(year, month, day).toISOString();
};

export const isTimeSlotSameDayAsSelectedSlot = (
  timeSlotDate: string,
  selectedSlotDate: string,
): boolean => {
  const isBothDateTime =
    timeSlotDate.includes('T') && selectedSlotDate.includes('T');
  if (isBothDateTime) {
    return isSameDay(timeSlotDate, selectedSlotDate);
  }
  return isSameDay(timeSlotDate, convertDateToZulu(selectedSlotDate));
};

export const formatDate = (
  from: string,
  to: string,
  location: ServiceLocation,
  locale: Locale,
  t: (a: string) => string,
  appConfig: typeof CSS_CONFIG,
): string => {
  const { dateAndTime } = appConfig.formats;
  const dateFormat = dateAndTime.date;
  const timeFormat = dateAndTime.time;
  const { currentTimeZone } = timeZoneHelper(location, t, appConfig);
  const inStoreDate = removeTimePartFromDate(from);
  if (isTimeInBrowserSettings(location, appConfig)) {
    return `${format(parseISO(from), `${dateFormat}, ${timeFormat}`, {
      locale,
    })} - ${format(parseISO(to), timeFormat, {
      locale,
    })} ${currentTimeZone}`;
  }

  return `${format(parseISO(inStoreDate), dateFormat, {
    locale,
  })}, ${convertedTime(from, false, appConfig)} - ${convertedTime(to, false, appConfig)}`;
};
